import {
  GraphQLTypes,
  InputType,
  Selector
} from '~/__generated__/backend/zeus';
import { g } from '~/globals';
import { gqlQueryClient } from '~/lib/backend';

// Selector is separated so we can infer the selector type
const selector = Selector('Query')({
  me: {
    user: {
      id: true,
      email: true,
      firstName: true,
      lastName: true,
      // Used to identify if current user have a group level permission
      userGroup: [
        {
          first: 1,
          filter: {
            isSuspended: false
          }
        },
        {
          edges: {
            node: {
              role: true,
              groupId: true
            }
          }
        }
      ],

      notifications: [
        {
          first: 10,

          // Filter oly for Unread announcements
          isUnread: true,
          filter: {
            announcementId: {
              not: null
            }
          }
        },
        {
          edges: {
            node: {
              id: true,
              announcement: {
                markdownText: true,
                id: true
              }
            }
          }
        }
      ]
    },
    staffAt: {
      dealershipId: true,
      dealershipName: true,
      role: true,
      extraPermissions: true,

      dealershipGroupId: true,
      dealershipGroupName: true,
      groupRole: true
    }
  }
});

const queryKey = ['profile'];

export default function meQuery() {
  return {
    enabled: true,
    queryKey,
    queryFn: () => {
      return gqlQueryClient({ throwOnError: true, dealershipId: null })(
        selector
      );
    }
  };
}

export const resetMeQuery = async () => {
  await g.reg.queryClient.resetQueries({
    queryKey
  });
};

export type MeQueryType = InputType<GraphQLTypes['Query'], typeof selector>;
